import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserInput } from '../../Redux/Slice/selectedProductsSlice';

const Input = ({label, info, description, unity, type, section, inputKey}) => {
  const dispatch = useDispatch();
  const { userInputs } = useSelector(state => state.selectedProducts);
  
  const [value, setValue] = useState('');
  
  // Charger la valeur sauvegardée au montage
  useEffect(() => {
    const savedInput = userInputs[section]?.[inputKey];
    if (savedInput) {
      // Si c'est un objet avec value, utiliser la value
      if (typeof savedInput === 'object' && savedInput.value !== undefined) {
        setValue(savedInput.value);
      } else {
        // Sinon utiliser directement la valeur
        setValue(savedInput);
      }
    }
  }, [section, inputKey, userInputs]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    
    // Sauvegarder dans Redux avec le format complet (label, value, unity)
    dispatch(setUserInput({
      section,
      input: {
        ...userInputs[section],
        [inputKey]: {
          label: label,
          value: newValue,
          unity: unity
        }
      }
    }));
  };

  return(
    <>
      <div className="indiquez-surface container mt- d-flex align-items-center">
        <label>{label}</label>
        <input
          type={type}
          value={value}
          onChange={handleChange}
          className="border-end-0 ms-4"
          style={{ width: "auto" }}
        />
        <div className="M2">
          <span className="text-2">{unity}</span>
        </div>
      </div>
      <div className="calcul container mt-5">
        <p className="">{info}</p>
        <p className="" style={{ fontWeight: "bold" }}>
          {description}
        </p>
      </div>
    </>
  )
}

export default Input